module.exports = __webpack_public_path__ + "img/10_6.87272e78.png";